export function checkIfLocationSpecificPage(path) {
    // Check if the user is on a location summary page (if the path contains 'locations' but is not followed by 'list' or 'map')
    const locationsRegex = /locations(?!\/list|\/map)/;
    // Check if the user is on a location detail page (if path contains ('kw-demand'))
    const kwDemandRegex = /kw-demand/;
    return (kwDemandRegex.test(path) || locationsRegex.test(path));
}

// Converts accented characters to unaccented characters and replaces special EU characters with their unaccented equivalents
// Used to enable accent-insensitive searching and comparison
export function convertToPlainText(value, skipLowercase = false) {
    if (!value) return '';
    let result = value
        .normalize("NFD") // decomposes combined letters into letter + accent
        .replace(/\p{M}/gu, "") // removes all accent marks
        // replaces EU special letters that aren't marks
        .replace(/ß/g, "ss") 
        .replace(/æ/g, "ae")
        .replace(/œ/g, "oe")
        .replace(/ø/g, "o")
        .replace(/đ/g, "d")
        .replace(/ł/g, "l");

    if (!skipLowercase) {
        result = result.toLowerCase();
    }

    return result;
}

// Format number based on user locale, with options adding commas for thousands and decimal places
export function formatNumber(value, userSettings, options: { useGrouping?: boolean; decimals?: number } = {}) { 
  if (value === null || value === undefined) return;

  // Convert string to number if needed
  const numValue = typeof value === 'string' ? parseFloat(value) : value;

  const locale = userSettings?.currency === 'EUR' ? 'de-DE' : 'en-US';
  const useGrouping = options.useGrouping ?? false; 
  const hasExplicitDecimals = options.decimals !== undefined; 
  
  if (!useGrouping && !hasExplicitDecimals) { // return value as is
    return numValue.toLocaleString(locale, {
      useGrouping: false, // toLocaleString adds commas by default so we need to explicitly disable
      maximumFractionDigits: 20 // set a high max to avoid truncating decimals if they exist, since we aren't explicitly formatting them
    });
  }

  const decimals = hasExplicitDecimals 
    ? options.decimals
    : Number.isInteger(numValue)
      ? 0 // if integer, default to no decimal places
      : 2; // if float, default to 2 decimal places

  return numValue.toLocaleString(locale, {
    useGrouping,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}